module.exports = __webpack_public_path__ + "static/media/img_62.e157d7f9.png";